import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import { QUEUE_URL } from 'app/router/constants/externalUrls';
import ActionLink from 'app/components/Links/ActionLink.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import CallToAction from 'app/components/layout/CallToAction.styled';
import { watchListNavigated } from 'app/features/watchlist/actions';

const UI = ({ watchListNavigated }) => (
  <ActionLink
    data-t="series-see-all"
    as={LocalizedLink}
    to={QUEUE_URL}
    onClick={watchListNavigated}
  >
    <CallToAction size="l">
      <FormattedMessage id="success_cards_cta" />
    </CallToAction>
  </ActionLink>
);

UI.propTypes = {
  watchListNavigated: PropTypes.func.isRequired,
};

UI.displayName = 'SeeAll';

const SeeAll = connect(null, { watchListNavigated })(UI);

export default SeeAll;
